import clsx from 'clsx';
import { textLgSemibold, textMd } from '@insify/design-system/typography';
import { Button } from '~components/Button';
import { ComponentLink } from '~components/ComponentLink';
import { Image } from '~components/Image';

import * as styles from './Card.module.css';

import type { CardColor, ContentfulComponentCard } from '~components/types';

type CardProps = {
  card: ContentfulComponentCard;
  className?: string;
};

export const Card: React.FC<CardProps> = ({ card, className }) => {
  const backgroundColor: CardColor = card.backgroundColor || 'Protective Purple 10';
  const colorClassName = styles[getColorClassName(backgroundColor)];

  return (
    <div className={clsx(styles.card, colorClassName, className)}>
      {card.image && <Image image={card.image} className={styles.image} />}
      <div className={clsx(styles.title, textLgSemibold)}>{card.title}</div>
      <div className={clsx(styles.description, textMd)}>{card.description}</div>
      <Button className={styles.button} element={<ComponentLink link={card.link} />}>
        {card.link.label}
      </Button>
    </div>
  );
};

const getColorClassName = (color: CardColor) => color.toLowerCase().replaceAll(' ', '');
